import { IResponse } from '../types';
import axiosInstance from '../axiosInstance';
import { requestResources } from '../requestResources';
import {
  IChat,
  IChatMessage,
  ICreateChatPayload,
  IPusherConfig,
  ISendMessagePayload,
} from './types';

const { clientPortalChats } = requestResources;

export const getChats = (search: string, days?: number): IResponse<IChat[]> => {
  const params = new URLSearchParams();
  params.set('search', search);
  if (typeof days === 'number') {
    params.set('days', String(days));
  }
  return axiosInstance.get(`${clientPortalChats}/chats?${params.toString()}`);
};

export const getChat = (chatId: number): IResponse<IChat> =>
  axiosInstance.get(`${clientPortalChats}/chats/${chatId}`);

export const createChat = (payload: ICreateChatPayload): IResponse<IChat> =>
  axiosInstance.post(`${clientPortalChats}/chats`, payload);

export const sendMessage = (payload: ISendMessagePayload): IResponse<IChatMessage> =>
  axiosInstance.post(`${clientPortalChats}/chats/${payload.chatId}/messages`, payload);

export const readMessage = (chatId: string): IResponse<void> =>
  axiosInstance.post(`${clientPortalChats}/chats/${chatId}/read`);

export const getChatMessages = (chatId: number): IResponse<IChatMessage[]> =>
  axiosInstance.get(`${clientPortalChats}/chats/${chatId}/messages`);

export const closeChat = (chatId: number): IResponse<boolean> =>
  axiosInstance.get(`${clientPortalChats}/chats/${chatId}/close`);

export const getPusherConfig = (): IResponse<IPusherConfig> =>
  axiosInstance.get(`${clientPortalChats}/get-pusher-settings`);

export const sendChatAttachment = (
  chatId: string | number,
  file: FormData,
  fileType: string,
): IResponse<IChatMessage> =>
  axiosInstance.post(`${clientPortalChats}/chats/${chatId}/attachments`, file, {
    headers: {
      'Content-Type': fileType,
    },
  });

export const reopenChat = (chatId: number): IResponse<boolean> =>
  axiosInstance.put(`${clientPortalChats}/chats/${chatId}/reopen`);
